
$(".pin-games-slider").not('.slick-initialized').slick({
    slidesToShow: 1,
    dots: true,
    rtl: true,
    infinite: false,
    arrows: true,
    adaptiveHeight: true,
    slidesToScroll: 1,
    prevArrow: '<div class="a-right control-c prev slick-prev slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"></path></svg></div>',
    nextArrow: '<div class="a-right control-c next slick-next slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"></path></svg></div>',
});

$(".popular-games-items").not('.slick-initialized').slick({

    slidesToShow: 6,
    dots: false,
    rtl: true,
    infinite: false,
    arrows: true,
    adaptiveHeight: true,
    slidesToScroll: 6,
    prevArrow: '<div class="a-right control-c prev slick-prev slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"></path></svg></div>',
    nextArrow: '<div class="a-right control-c next slick-next slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"></path></svg></div>',
    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows:false

            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows:false

            }
        },
        {
            breakpoint: 480,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows:false
            }
        }
        ]
});
